export { default } from './CTAVersionLifecycle';
